import script from "./EditTinymceBox.vue?vue&type=script&setup=true&lang=js"
export * from "./EditTinymceBox.vue?vue&type=script&setup=true&lang=js"

import "./EditTinymceBox.vue?vue&type=style&index=0&id=3da6b453&lang=scss"

const __exports__ = script;

export default __exports__